window.onload = function() {
  var locationPopupSelection = document.getElementById("locationPopupSelection");

  // Condition pour afficher ou masquer le popup
  if (document.cookie.indexOf("countryPopupSeen") == -1) {
    locationPopupSelection.style.display = "flex";
    setCookie("countryPopupSeen", 30);
  } else {
    closedPopupLocation()
  }

  function setCookie(name, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + expires + "; path=/";
  }

};

//fermeture du popup location
function closedPopupLocation(){
  locationPopupSelection.style.display = "none";
}